import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetCategorySubCate = createAsyncThunk(
  "getCategorySub/GetCategorySubCate",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.GETCATEGORY}?parentId=${id}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetCategorySubCateSlice = createSlice({
  name: "SubCategory",
  initialState: {
    SubCategory: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetCategorySubCate.fulfilled, (state, action) => {
        state.SubCategory = action.payload;
      })
      .addCase(GetCategorySubCate.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetCategorySubCateSlice.reducer;
